import { defineMessages } from 'react-intl';

export default defineMessages({
  createPullRequestLinkText: {
    id: 'frontbucket.branches.createPullRequestLinkText',
    description:
      'Text for the link to create a pull request from the branches list',
    defaultMessage: 'Create',
  },
});
